import { useMemo } from 'react';
import { BackgroundThemeRevision, ColorId } from 'referral-types';
import { rgbStringToHex } from '../../../../../utils/colorUtils';
import { useTheme } from '../../../../../context/theme/useTheme';
import { useBodyStyleVersion } from '../../../../../hooks/useBodyStyleVersion';
import { getCssVariableForColorId } from '../../../../../constants';

export interface GridSubthemeProps {
  themeRevision?: Partial<BackgroundThemeRevision>;
}

export const useGridSubthemeColors = (
  themeRevision: Partial<BackgroundThemeRevision> | undefined,
  defaults: { colorId1: ColorId; colorId2: ColorId },
) => {
  const { isDarkMode } = useTheme();
  const bodyStyleVersion = useBodyStyleVersion();
  const { colorId1, colorId2 } = themeRevision || {};

  return useMemo(() => {
    const colorStyles1 = getCssVariableForColorId(colorId1 || defaults.colorId1, isDarkMode);
    const colorStyles2 = getCssVariableForColorId(colorId2 || defaults.colorId2, isDarkMode);
    const rootStyles = getComputedStyle(document.body);

    const color1 = rgbStringToHex(rootStyles.getPropertyValue(colorStyles1).trim() || '20 20 20');
    const color2 = rgbStringToHex(rootStyles.getPropertyValue(colorStyles2).trim() || '255 255 255');

    return { color1, color2, isDarkMode };
  }, [colorId1, colorId2, defaults.colorId1, defaults.colorId2, isDarkMode, bodyStyleVersion]);
};
